import { statusMeta } from "@/data/mockData";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, className }) => {
  const meta = statusMeta[status] || { label: status, cls: "bg-slate-100 text-slate-700" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap",
        meta.cls,
        className
      )}
    >
      {meta.label}
    </span>
  );
};
